import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/logo.svg';
import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';
import './PaymentErrorPage.scss';

const PaymentErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-page-wrapper">
      <SEO {...getRouteMeta('/payment/error')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />

      <div className="payment-error-page">
        <div className="container">
          <div className="error-container">
            <div className="error-animation">
              <div className="error-icon">⚠️</div>
            </div>

            <h1>Error en el Pago</h1>
            <p className="error-message">
              No pudimos procesar tu pago en este momento. Esto puede deberse a
              varias razones:
            </p>

            <div className="error-reasons">
              <div className="reason-item">
                <span className="reason-icon">💳</span>
                <p>Problemas con tu tarjeta o método de pago</p>
              </div>
              <div className="reason-item">
                <span className="reason-icon">⏱️</span>
                <p>La sesión de pago expiró</p>
              </div>
              <div className="reason-item">
                <span className="reason-icon">🌐</span>
                <p>Problemas de conexión a internet</p>
              </div>
              <div className="reason-item">
                <span className="reason-icon">🔒</span>
                <p>El pago fue cancelado</p>
              </div>
            </div>

            <div className="error-help">
              <h3>¿Qué puedes hacer?</h3>
              <ul>
                <li>
                  Verifica que tu método de pago sea válido y tenga fondos
                  suficientes
                </li>
                <li>Intenta nuevamente agendando una nueva cita</li>
                <li>Si el problema persiste, contáctanos y te ayudaremos</li>
              </ul>
            </div>

            <div className="error-actions">
              <button
                className="btn-primary"
                onClick={() => navigate('/asesoria')}
              >
                Intentar Nuevamente
              </button>
              <button
                className="btn-secondary"
                onClick={() => navigate('/contacto')}
              >
                Contactar Soporte
              </button>
            </div>

            <div className="error-note">
              <p>
                <strong>Nota:</strong> Si el cargo ya fue realizado pero ves
                este mensaje, por favor contáctanos inmediatamente.
                Verificaremos tu pago y confirmaremos tu reserva.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <Scrollbar />
    </div>
  );
};

export default PaymentErrorPage;
